'use client';
import React from 'react';
import HiperaliaInfoSection from '@/components/common/HiperaliaInfoSection';

interface AboutSectionProps {
  className?: string;
}

const AboutSection: React.FC<AboutSectionProps> = ({ className = '' }) => {
  return (
    <div data-component-id="src/components/sections/AboutSection.tsx:11:4" data-component-path="src/components/sections/AboutSection.tsx" data-component-line="11" data-component-file="AboutSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`${className}`}>
      <div data-component-id="src/components/sections/AboutSection.tsx:12:6" data-component-path="src/components/sections/AboutSection.tsx" data-component-line="12" data-component-file="AboutSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20justify-center%20w-full%22%7D" className="flex justify-center w-full">
        <HiperaliaInfoSection data-component-id="src/components/sections/AboutSection.tsx:13:8" data-component-path="src/components/sections/AboutSection.tsx" data-component-line="13" data-component-file="AboutSection.tsx" data-component-name="HiperaliaInfoSection" data-component-content="%7B%22elementName%22%3A%22HiperaliaInfoSection%22%7D" />
      </div>
    </div>
  );
};

export default AboutSection; 